<template>
  <ModalDialog
    ref="dialog"
    title="Send Credit Note Receipt"
    :submitting="submitting"
    :scrollable="true"
    :submitDisabled="currentlyUploading"
    submitTitle="Send Receipt"
    icon="fa-envelope-open-text"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <EmailMessageForm 
        :contactId="contactId"
        :templateType="MessageTemplateTypes.creditNote"
        :messageTemplateUpdateFn="messageTemplateUpdateFn"
        :previewLink="previewLink"
        @uploading="currentlyUploading = $event"
        @update="emailDetails = $event"
      />
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'

import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { MessageTemplateTypes } from '@/store/types'

export default {
  name: 'SendCreditNoteDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    contactId: Number,
    creditNoteId: Number,
  },
  data() {
    return {
      dialogForm: {},
      emailDetails: { },
      submitting: false,
      currentlyUploading: false,

      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    previewLink() {
      return `/accounts/creditnotes/${this.creditNoteId}/report`
    }
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var emailData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        emailPersonList: this.emailDetails.contactPersonList.map(person => { return { contactPersonId: person.id } }),
        uploadFileList: this.emailDetails.uploadFileList,
        ccList: this.emailDetails.ccList
      }

      this.$apiService.accountsService.sendCreditNoteEmail(this.creditNoteId, emailData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.accountsService.getCreditNoteSendReceiptTemplate(this.creditNoteId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>